import _ from 'lodash';
import log from 'loglevel';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import packageJson from '../../package.json';

const isNative = Capacitor.isNativePlatform();
const platform = Capacitor.getPlatform();

let config = null;
const appPlatform = process.env.PLATFORM;
const appVersion = packageJson.version;
// path ของ DRM key endpoint (skooldio-vdo-key) — xhr ที่ uri มี path นี้จะแนบ Bearer + video access token
const DEFAULT_DRM_LICENSE_PATH = '/license/drm/';
const defaultConfig = {
  cookieSyncDomain: 'localhost:4001',
  userApi: 'http://localhost:4001/api/users',
  graphApi: 'http://localhost:4001/graphql',
  examApi: 'http://localhost:4001/api/cr-exams',
  storeGraphApi: 'http://localhost:4001/graphql',
  classroomTimeInterval: 60000,
  classroomVerifyInterval: 60000,
  translationMode: false,
  skooldioClassroom: 'http://localhost:3003/class',
  isOpenExtLink: false,
  skooldioLogin: {
    /**
     * skooldioLogin mode configuration for customize platform login view,
     * Now support ANY and PaaS Product with ANY configuration by default;
     *
     * mode: can be one of type 'PAAS' or 'ANY' | default: 'ANY'
     */
    mode: 'ANY',
    registerURL: 'http://shoponline.ondemand.in.th/shop.ondemand/frontend/web/register/create',
    showLoginForm: false,
    passportProviders: [
      // {
      //   provider: 'ondemand',
      //   btnTransKey: 'LOGIN.FORM.SUBMIT.LABEL',
      //   loginURL: 'http://localhost:5001/api/login/ondemand',
      //   secureLoginUrl: 'http://localhost:5001/api/login/ondemand/secureLogin',
      //   secureLoginAppId: '',
      //   secureLoginAppSecret: '',
      // },
      // {
      //   provider: 'learned',
      //   btnTransKey: 'LOGIN.FORM.SUBMIT.LABEL',
      //   loginURL: 'http://localhost:5001/api/login/learned',
      //   secureLoginUrl: 'http://localhost:5001/api/login/learned/secureLogin',
      //   secureLoginAppId: '',
      //   secureLoginAppSecret: '',
      // },
    ],
  },
  studentApi: 'http://localhost:5000/api/cr-students',
  googleAnalyticsId: 'UA-XXXXX',
  clarityAnalytics: {
    enableClarity: false,
    clarityId: '',
  },
  global: {
    disableNavbar: false,
    pageSuffix: '',
    loading: {
      type: 'ICON', //'ICON', 'IMAGE'
      imageUrl: '',
    },
  },
  sidebarLinks: [{ key: 'logout', url: '/logout' }],
  videoPlayer: {
    watermarkType: 'onlyDisplayName', // onlyDisplayName, withPhoneNumber
    resumeVideo: {
      enable: true,
      updateFactor: 4,
      resumeOffsetSec: 10,
    },
    completedPercentage: 90,
    showVideoInfo: false,
    showVideoController: false,
    disableFullscreen: true,
    bigPlayButton: false,
    showUserOverlay: true,
    showVideoOverlayOnPause: false,
    showVideoOverlayOnEnd: false,
    enableDoubleTapsVideoPlayer: false,
    // [LAMS-2441] speed ที่เลือกได้ แยกตาม BU (login provider: ondemand/learned)
    // ไม่ระบุ provider หรือใส่ [] = player ใช้ default [2, 1.75, 1.5, 1.25, 1, 0.75]
    // ตั้งค่าจริงราย deployment ผ่าน window.appConfig
    playbackRatesByProvider: {},
    // ตั้งค่าจริงราย deployment ผ่าน window.appConfig (od-at-home-deployment) · ค่าว่าง = ใช้ default
    drmLicensePath: DEFAULT_DRM_LICENSE_PATH,
  },
  log: 'error',
  isMaintenance: false,
  announcement: '<h3>ปรับปรุงระบบถึง 16:00 @ 21 มีนาคม 2562</h3>',
  appVersion,
  /**
   * classroom configuration for customize classroom view,Now support ANY and PaaS Product with ANY configuration by default;
   *
   * layoutType: can be one of type 'FIXED' or 'FULL' | default: 'FULL'
   * allowContentType: allow content and ordering priority which can be list of type ['VIDEO','ARTICLE','SLIDES','EXTERNAL','YOUTUBE','QUIZ','OTHER','QUIZ_SIMPLE','MATERIAL'] | default: ['VIDEO','QUIZ']
   * quizTimer: allow quiz countdown timer default: false
   */
  classroom: {
    layoutType: 'FULL',
    allowContentType: ['VIDEO', 'QUIZ', 'EBOOK'],
    disableToCBackToMyCourse: false,
    hideSubsectionTitle: false, // configuration to display or non-display subsection title on classroom content
    enableSlideFullscreenMode: false, // Full-screen mode of slide on video-slide content
    enableClassroomVerificationHeartbeat: false,
    enableGraduateModal: false,
    enableExitModal: false,
    disableMarkCompletedOnTrialCourse: false,
    disableToCBackToCourseDetail: false,
    enableToggleMiniModeOnSubsectionClick: false,
    // enableGetAssetByAssetId: true, // deprecated: old signed-url mutations closed; always uses generateClassroomCourseAssetSignedUrls now
    quiz: {
      bgColor: 'primary',
      showEstimatedTime: true, // estimated time on quiz detail page
      showTimer: true,
      imagePrefix: '', // for images used in quiz -> skooldio-, tmk-
      imageSuffix: 'svg', // png, svg
      enableSubmitAnswerOnEachQuestion: true, // Enable call GraphQL when submit answer on each question
      gradedExam: {
        allowPreviousAnswersView: false, // allow tapping on table's row to view answers from the tapped round
        showPassingCriteria: true, // passing criteria on quiz detail page
        showAnswersConfirmation: false, // confirm answers before submitting
        showResult: false, // show Result page
        showSolution: false, // allow viewing solutions
      },
    },
    ebook: {
      qrUrl: 'http://localhost:3000/courseCode/:courseCode/subsection/:subsectionReferId',
      qrRef: 'additional6',
      enableQRRef: false,
    },
    liveCoding: {
      disableWarningModal: false,
    },
    material: {
      downloadAsFlutter: false,
    },
  },
  //  uiVariant configuration for customize ui for each project which can be list of project ['ANY','PAAS'].
  uiVariant: 'ANY', // default is 'ANY'
  uiVariantSet: 'A', // 'A', 'B', 'C'
  myCourses: {
    courseFilter: 'default', // 'default', 'withoutCourseFilter', 'withoutProgress'
    enableCourseFilterAndSort: false,
    enableCourseSubjectFilter: false,
    enableFullScreenEmptyCourses: false,
    browseCoursesUrl: '',
    emptyCoursesUrl: '',
    maxRecentCoursesCount: 5,
    bannerUrl: '',
  },
  notification: {
    type: 'TIPS',
  },
  isAppUrlListenerEnabled: true,
  localCaching: {
    isEnabled: false,
    path: 'https://ondemand.local/.cdn-trace',
  },

  // Features
  disableMyCoursesRoute: false,
  disableLoginRoute: false,
  enableDiscussion: false,

  subjectList: [],
  watermarkApi: 'https://asia-southeast1-ondemand-athome.cloudfunctions.net/watermarkWithQR_dev',
  watermarkPDF: {
    titleTemplate: '{firstname} {lastname}', // each `{field}` will be replaced with user.field, same addition field store different data depends on project
    subtitleTemplate: '',
  },

  enableNativeAppRoute: false,
  enableQRScan: false, // Show QR Scanner Icon for MoE Book
  MoEBookRedirectApi: '', // Redirect Service for the QR Scanner

  firebase: {
    config: {
      apiKey: 'AIzaSyDX3Y_-DvBBfKR9J_hAVdVClZw5PtuNWBw',
      authDomain: 'anywhere-lms-stg.firebaseapp.com',
      projectId: 'anywhere-lms-stg',
      storageBucket: 'anywhere-lms-stg.appspot.com',
      messagingSenderId: '1071923881338',
      appId: '1:1071923881338:web:98f525ee36fa061284a2c3',
      measurementId: 'G-XYJRLXJ69E',
    },
    authenticationServiceApi:
      'https://asia-southeast2-anywhere-lms-stg.cloudfunctions.net/anywhere-firebase-auth-service',
    enable: false,
  },
  // FIXME: revisit config naming
  /**
   *  proposal:
   *  userReviewAnywhere: {
   *    enabled: false,
   *    daysToReset: 180,
   *  }
   */
  feedback: {
    enable: false,
    date_duration: 180,
  },
  native: {
    enablePushNotification: false,
  },
};

const getRemoteConfig = async ({ remoteConfigPath, appPlatformVersion }) => {
  const remoteConfig = await fetch(remoteConfigPath, {
    headers: new Headers({
      'x-learn-anywhere-version': `${appPlatform}-${appVersion}`,
    }),
  }).then((res) => res.json());
  config = _.defaultsDeep(
    {},
    remoteConfig,
    window.appVersionConfig?.[appPlatformVersion] ?? {},
    window.appConfig,
    window.subscription,
    window.routeConfig,
    defaultConfig
  );
  log.debug('getRemoteConfig', config);
};

const getAsyncConfig = async () => {
  const deviceInfo = await Device.getInfo();

  // FIXME: For workaround appVersion from Capacitor when contextIsolation is true
  let platform = deviceInfo?.platform;
  let appVersion = deviceInfo?.appVersion;
  let appPlatformVersion = `${platform}-${packageJson.version}`;

  const isElectron = !!window.electron?.isElectron;
  if (isElectron) {
    platform = window.electron.platform;
    appVersion = await window.electron.getAppVersion();
    appPlatformVersion = `${platform}-${appVersion}`;
  }

  if (isNative && (platform === 'ios' || platform === 'android')) {
    const appInfo = await App.getInfo();
    appPlatformVersion = `${deviceInfo?.platform}-${appInfo?.version}`;
  }

  config = _.defaultsDeep(
    {},
    window.appVersionConfig?.[appPlatformVersion] ?? {},
    window.appConfig,
    window.subscription,
    window.routeConfig,
    defaultConfig
  );
  const { remoteConfigPath } = config;
  if (remoteConfigPath) {
    await getRemoteConfig({ remoteConfigPath, appPlatformVersion });
  }
  return config;
};

function getConfig() {
  if (config === null) {
    config = _.defaultsDeep(
      {},
      window.appConfig,
      window.subscription,
      window.routeConfig,
      defaultConfig
    );
    getAsyncConfig();
    log.setLevel(config.log);
    log.debug(config);
  }
  return config;
}

export default getConfig;
export { getAsyncConfig, DEFAULT_DRM_LICENSE_PATH };

/**
 * @typedef MeasurementProtocolConfig
 * @property {string} id
 * @property {string} url
 * @property {string} apiSecret
 */
